import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import CommonHeadingNBtns from "../common-components/CommonHeadingNBtns";
import SelectDropdown from "../components-react/SelectDropdown";
import { showConfirmAlert } from "../components-react/ReactAlert";
import { commonPostPutApi } from "../../redux/reducers/commonApiSlice";
import { add_vendor, update_vendor } from "../../data/ApiEndpoints";

const validateForm = (formValues, isAdmin) => {
  let errors = {};
  const mobileRegex = /^\d{10}$/;

  if (!formValues.vendorName) {
    errors.vendorName = "Vendor Name Required!";
  }

  if (!formValues.vendorMobile) {
    errors.vendorMobile = "Vendor Mobile Required!";
  } else if (!mobileRegex.test(formValues.vendorMobile)) {
    errors.vendorMobile = "Invalid mobile number!";
  }

  if (!formValues.selectedCategory) {
    errors.selectedCategory = "Category Required!";
  }

  if (isAdmin && !formValues.selectedGym) {
    errors.selectedGym = "Gym Required!";
  }

  return errors;
};

const VendorForm = ({
  userInfoData,
  rowData,
  isEdit,
  closeModal,
  callFunction,
  selectedExpenseCategory,
  allCategoriesData,
  selectedGym,
  gymData,
}) => {
  const dispatch = useDispatch();
  const { postPutLoading } = useSelector((state) => state.common);

  // const isAdmin = userInfoData?.account_type === "cluster_manager";
  const isAdmin = userInfoData?.account_type === "admin";

  const forminitials = {
    vendorName: isEdit && rowData?.name ? rowData.name : "",
    vendorMobile: isEdit && rowData?.mobile ? rowData.mobile : "",
    selectedCategory:
      isEdit && rowData?.expense_category && rowData?.expense_category_name
        ? {
            label: rowData.expense_category_name,
            value: rowData.expense_category,
          }
        : selectedExpenseCategory || "",
    selectedGym:
      isEdit && rowData?.gym_id && rowData?.gym_name
        ? {
            label: rowData.gym_name,
            value: rowData.gym_id,
          }
        : selectedGym || "",
    isActive: isEdit ? (rowData?.status === "active" ? true : false) : true,
  };
  const [formValues, setFormValues] = useState(forminitials);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  console.log("userInfoData?.gym_id", userInfoData?.gym_id);
  console.log("formValues", formValues);

  const onChangeInput = (e) => {
    const { name, value, type, checked } = e.target;

    const updatedValue = name === "vendorMobile" ? value.slice(0, 10) : value;

    setIsSubmit(false);

    setFormValues((prevs) => ({
      ...prevs,
      [name]: type === "checkbox" ? checked : updatedValue,
    }));
  };

  const onChangeDropdown = (value, name) => {
    setIsSubmit(false);
    setFormValues({ ...formValues, [name]: value });
  };

  const onSubmit = () => {
    setFormErrors(validateForm(formValues, isAdmin));
    setIsSubmit(true);
  };

  const handleSubmitForm = async (payload) => {
    const method = isEdit ? "PUT" : "POST";
    const endpoint = isEdit ? update_vendor : add_vendor;
    const token = userInfoData?.token || "";

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        setIsSubmit(false);
        setFormValues(forminitials);
        callFunction();
        closeModal();
        toast.success(result?.payload?.message || "Success!");
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  useEffect(() => {
    if (isSubmit && Object.keys(formErrors)?.length === 0) {
      const userData = {
        name: formValues.vendorName || "",
        mobile: formValues.vendorMobile || "",
        gym_id: isAdmin
          ? formValues.selectedGym?.value || ""
          : userInfoData?.gym_id || userInfoData?.uid || "",
        expense_category: formValues.selectedCategory?.value || "",
        status: formValues.isActive ? "active" : "inactive",
      };

      if (isEdit) {
        userData.uid = rowData?.uid || "";
      }

      const handleConfirm = async () => {
        handleSubmitForm(userData);
      };

      showConfirmAlert(
        handleConfirm,
        `Are you sure!`,
        "Vendor Form",
        `${isEdit ? "Update" : "Add"} Vendor`
      );
    }
  }, [isSubmit, formErrors]);

  return (
    <div className="createNewCTOModalContainer mod-width-50p">
      <CommonHeadingNBtns
        title={`${isEdit ? "Update" : "Add"} Vendor`}
        onClose={closeModal}
        onClick={onSubmit}
        isLoading={postPutLoading}
      />
      <form className="formContainer">
        <div className="formInputsGrid twoGridSystem">
          <div className="formInputBox">
            <label htmlFor="vendorName" className="formInputLabel">
              vendor name <span className="required">*</span>
            </label>

            <input
              type="text"
              placeholder="Enter Vendor Name"
              className={`formInput ${
                formErrors?.vendorName ? "formError" : ""
              }`}
              name="vendorName"
              value={formValues.vendorName}
              onChange={onChangeInput}
            />
          </div>

          <div className="formInputBox">
            <label htmlFor="vendorMobile" className="formInputLabel">
              vendor mobile <span className="required">*</span>
            </label>

            <input
              type="number"
              placeholder="Enter Vendor Mobile"
              className={`formInput ${
                formErrors?.vendorMobile ? "formError" : ""
              }`}
              name="vendorMobile"
              value={formValues.vendorMobile}
              onChange={onChangeInput}
            />
          </div>

          <div className="formInputBox span2">
            <label htmlFor="selectedCategory" className="formInputLabel">
              vendor category <span className="required">*</span>
            </label>

            <div
              className={`commonWrapper ${
                formErrors?.selectedCategory && "formError"
              }`}
            >
              <SelectDropdown
                options={allCategoriesData || []}
                selectedOption={formValues.selectedCategory}
                setSelectedOption={(selectedValue) =>
                  onChangeDropdown(selectedValue, "selectedCategory")
                }
                name="Select Category"
                preventKeyboardOpen={true}
              />
            </div>
          </div>

          {isAdmin && (
            <div className="formInputBox span2">
              <label htmlFor="selectedGym" className="formInputLabel">
                select gym <span className="required">*</span>
              </label>

              <div
                className={`commonWrapper ${
                  formErrors?.selectedGym && "formError"
                }`}
              >
                <SelectDropdown
                  options={gymData || []}
                  selectedOption={formValues.selectedGym}
                  setSelectedOption={(selectedValue) =>
                    onChangeDropdown(selectedValue, "selectedGym")
                  }
                  name="Select Gym"
                  preventKeyboardOpen={true}
                />
              </div>
            </div>
          )}

          <div className="formInputBox">
            <label className="formInputLabel">status</label>
            <div className="commonWrapper commonSwitchWrapper no-border">
              <label className="commonSwitch">
                <input
                  type="checkbox"
                  name="isActive"
                  checked={formValues.isActive}
                  onChange={onChangeInput}
                />
                <span className="slider round"></span>
              </label>
              <span className="formInputLabel">
                {formValues.isActive ? "Active" : "Inactive"}
              </span>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default VendorForm;
